import { useTotalTermElementDetailViewSummaryPage } from './hooks';
import { InvestmentRealEstateSummarySumTable } from '../../../TtDetails';
import { TotalTermElementDetailViewInvestmentRealEstatePageProps } from './types';
import { SummaryPageContainer } from './components';

export function TotalTermElementDetailViewInvestmentRealEstatePage({
  householdID,
  onClickItem,
}: TotalTermElementDetailViewInvestmentRealEstatePageProps) {
  const { tPages } = useTotalTermElementDetailViewSummaryPage();

  return (
    <SummaryPageContainer
      heading={tPages('total-term-element-detail-view-investment-real-estate-summary-page-heading')}
      emptyDescription={tPages('total-term-element-detail-view-investment-real-estate-summary-page-empty-description')}
    >
      <InvestmentRealEstateSummarySumTable
        hideOnEmpty
        className="mt-10"
        householdID={householdID}
        onClickItem={onClickItem}
      />
    </SummaryPageContainer>
  );
}
